import React, { useEffect, useState } from "react";
import { getCRMHistory } from "./CRMHistoryLogic";
import ReactTable from 'react-table';
import { formatUTCtoPST } from "../../../shared/utility";
import { IconButton } from "@material-ui/core";
import CustomSimpleDialog from "../../../components/CustomDialog/CustomSimpleDialog";
import contactFields from "../Contacts/ContactsObj";
import companyFields from "../Companies/CompaniesObj";
import propertyFields from "../Properties/PropertiesObj";
import Loader from "../../../components/Loader/Loader";
import { transformFiles } from "./CRMHistoryLogic";

const RenderedHistory = props => {
    const { data, index, setView, all_history } = props;
    console.log('RenderedHistory', data, props);
    const json_data = data.data;
    const before_data = props.beforeData ? props.beforeData.data : null;
    console.log('before_data', before_data)
    const l = data;
    const dat = Object.keys(json_data).sort().map((fieldy) => {
                let field = '';
                let val = '';
                if (props.type === 'contact') {
                    if (fieldy !== 'files') {
                        field = contactFields[fieldy] ? contactFields[fieldy].label : '';
                        val = json_data[fieldy] ? json_data[fieldy] : ''
                    } else {
                        if (fieldy === 'files') {
                            // files
                            field = contactFields[fieldy] ? contactFields[fieldy].label : '';
                            val = transformFiles(json_data[fieldy]);
                        }
                    }
                }
                if (props.type === 'company') {
                    if (fieldy !== 'files') {
                        field = companyFields[fieldy] ? companyFields[fieldy].label : '';
                        val = json_data[fieldy] ? json_data[fieldy] : ''
                    } else {
                        if (fieldy === 'files') {
                            // files
                            field = companyFields[fieldy] ? companyFields[fieldy].label : '';
                            val = transformFiles(json_data[fieldy]);
                        }
                    }
                }
                if (props.type === 'property') {
                    if (fieldy !== 'files') {
                        field = propertyFields[fieldy] ? propertyFields[fieldy].label : '';
                        val = json_data[fieldy] ? json_data[fieldy] : ''
                    } else {
                        if (fieldy === 'files') {
                            // files
                            field = propertyFields[fieldy] ? propertyFields[fieldy].label : '';
                            val = transformFiles(json_data[fieldy]);
                        }
                    }
                }
                const style = {};
                let former = '';
                if (before_data) {
                    if (val && before_data[fieldy]) {
                        let before_val = before_data[fieldy];
                        if (fieldy === 'files') {
                            before_val = transformFiles(before_data[fieldy]);
                        }
                        if (val !== before_val) {
                            style.padding = 10;
                            style.backgroundColor = 'orange';
                            style.color = 'white';
                            style.fontWeight = 'bold';
                            former = `(Changed from "${before_val}")`;
                        }
                    }
                    if (val && !before_data[fieldy]) {
                        // new 
                        console.log('noob', val);
                        let dont_paint_green = false;
                        if (fieldy === 'files') {
                            if (typeof val === 'string') {
                                if (val.indexOf('0 file(s)') === -1) {
                                    dont_paint_green = true;
                                }
                            }
                        }
                        if (!dont_paint_green) {
                            style.padding = 10;
                            style.backgroundColor = 'green';
                            style.color = 'white';
                        }
                        style.fontWeight = 'bold';
                    }
                    if (!val && before_data[fieldy]) {
                        let before_val = before_data[fieldy];
                        if (fieldy === 'files') {
                            before_val = transformFiles(before_data[fieldy]);
                        }
                        style.backgroundColor = 'red';
                        style.color = 'white';
                        style.fontWeight = 'bold';
                        style.padding = 10;
                        former = `Deleted, used to be "${before_val}"`;
                    }
                }
                const obj = {
                    field: <div style={{paddingTop:10,paddingBottom:10}}>{field}</div>,
                    value: <div style={style}>
                            {val} {former}
                    </div>,
                    fieldy:field,
                    val,
                    former
                }
                return obj;
            }).filter(fd => {
                if (fd.fieldy) {
                    if (fd.val || fd.former) return true;
                }
            }).map((fd,index) => {
                const valueStyle = {
                    padding: 10
                };
                if (l.action_type === 'create') {
                    valueStyle.color = 'white';
                    valueStyle.backgroundColor = 'green';
                    valueStyle.padding = 10;
                    valueStyle.fontWeight = 'bold';
                }
                return <tr key={`tb-${index}`}>
                    <td style={{padding:10}}>
                        <div style={{paddingRight:20,fontWeight:'bold'}}>
                            <strong>{fd.field}</strong>
                        </div>
                    </td>
                    <td style={valueStyle}>
                        {fd.value}
                    </td>
                </tr>
            });
    return <>
        <p>#{index + 1}</p>
        <h4>{l.name}</h4>
        <p>
            {l.action_type ? `${l.action_type.toUpperCase()}D` : ''} - {formatUTCtoPST(l.timestamp)}
        </p>
        <p>
            <IconButton style={{marginRight:20}}
                disabled={index === 0 ? true : false}
                onClick={() => {
                    if (index > 0) {
                        const key = index - 1;
                        const dat = all_history;
                        setView([all_history[key], dat[key - 1], key]);
                    }
                }}
            >
                <i className="fa fa-chevron-left"></i>
            </IconButton>
            <IconButton
                style={{marginRight:20}}
                disabled={index === (all_history.length - 1) ? true : false}
                onClick={() => {
                    if (index < all_history.length) {
                        const key = index + 1;
                        const dat = all_history;
                        setView([all_history[key], dat[key - 1], key]);
                    }
                }}
            >
                <i className="fa fa-chevron-right"></i>
            </IconButton>
            <span style={{marginRight:20}}>
                <i className="fa fa-circle" style={{color:'orange'}}></i> - Updated value
            </span>
            <span style={{marginRight:20}}>
                <i className="fa fa-circle" style={{color:'green'}}></i> - New value
            </span>
            <span style={{marginRight:20}}>
                <i className="fa fa-circle" style={{color:'red'}}></i> - Deleted value
            </span>
        </p>
        <hr />
        <table>
            <tbody>
                {dat}
            </tbody>
        </table>
    </>
}

const CRMHistory = props => {
    const [dat, setDat] = useState(null);
    const [view, setView] = useState(null);

    const { data, type } = props;

    const getHistory = async (crmType, id) => {
        const entries = await getCRMHistory(crmType, id);
        console.log('entries', entries);
        setDat(entries);
    }

    useEffect(() => {
        if (type === 'contact') {
            getHistory('contact', data.id);
        }
        if (type === 'company') {
            getHistory('company', data.id);
        }
        if (type === 'property') {
            getHistory('property', data.id);
        }
    }, [])

    console.log('CRMHistory', props, dat, data);

    if (!dat) return <Loader />

    if (typeof dat === 'string') return null;

    const table_data = dat.filter(f => {
        if (f.data) {
            if (Object.keys(f.data).length < 3) {
                return false;
            }
        }
        if (f.data) return true;
    }).map((l, key) => { 
        console.log('ll', l)
        return ({
            id: l.id,
            name: l.name,
            date: formatUTCtoPST(l.timestamp),
            activity: l.action_type ? l.action_type.toUpperCase() : '',
            action: <>
                <IconButton
                    onClick={() => {
                        setView([l, dat[key - 1], key]);
                    }}
                >
                    <i className="fa fa-eye"></i>
                </IconButton>
            </>
        })
    });
    
    const columns = [
        {
            Header: "Date",
            accessor: "date" 
        },
        {
            Header: "Activity",
            accessor: "activity"
        },
        {
            Header: "User",
            accessor: "name"
        },
        {
            Header: "Action",
            accessor: "action"
        }
    ]
    

    return <>
        <h3>History</h3>
        <div className="table-adjust2">
            <ReactTable 
                filterable
                className='-striped -highlight' 
                showPaginationTop 
                showPaginationBottom 
                resizable={false} 
                defaultPageSize={10} 
                pageSizeOptions={[10, 20, 30]}
                sorted={[
                    {
                        id: 'id',
                        desc: true
                    }
                ]}
                data={table_data} 
                columns={columns}
                getTrProps={(state, rowInfo) => {
                    if (rowInfo && rowInfo.row) {
                      return {
                        onClick: (e) => {
                          
                          if (rowInfo) {
                            if (rowInfo.original) {
                              console.log('clicked', rowInfo, rowInfo.original)
                              const l = rowInfo.original;
                              const key = rowInfo.index;
                              //setView([l, dat[key - 1], key]);
                            }
                          }
                        }
                      }
                    } else {
                      return {}
                    }
                  }}
            />
        </div>

        {view && <CustomSimpleDialog 
            open={true}
            close={() => {
                setView(null);
            }}
            content={<>
                <RenderedHistory 
                    data={view[0]}
                    beforeData={view[1]}
                    type={type}
                    setView={setView}
                    all_history={dat}
                    index={view[2]}
                />
            </>}
        />}
    </>
}

export default CRMHistory;